module.exports = __webpack_public_path__ + "img/jinian.ce7d813c.png";